import { useAuthStore } from '../stores/authStore';

export const useHasPermission = (permission: string): boolean => {
  const user = useAuthStore((state) => state.user);
  
  // If no user, no permissions
  if (!user) return false;
  
  // Super admins have all permissions
  if (user.is_superuser) return true;
  
  // For now, we'll implement basic role-based checks
  // In a real app, this would check against user.permissions or user.roles
  
  // Staff users (teachers, principals) have most permissions
  if (user.is_staff) {
    // Teachers can create, read, update observations and assessments
    const teacherPermissions = [
      'observation.create',
      'observation.read',
      'observation.update',
      'observation.publish',
      'assessment.create',
      'assessment.read',
      'assessment.update',
      'assessment.publish',
      'child.read',
      'media.upload',
      'media.read',
      'media.delete',
    ];
    
    return teacherPermissions.includes(permission);
  }
  
  // Non-staff users have limited permissions
  const basicPermissions = [
    'observation.read',
    'assessment.read',
    'child.read',
    'media.read',
  ];
  
  return basicPermissions.includes(permission);
};

export const useHasRole = (role: string): boolean => {
  const user = useAuthStore((state) => state.user);
  
  if (!user) return false;
  
  // Map is_staff and is_superuser to roles
  if (role === 'admin' && user.is_superuser) return true;
  if (role === 'teacher' && user.is_staff) return true;
  if (role === 'user' && user.is_active) return true;
  
  return false;
};
